var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResendResultsIcon(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7994 18.7281L16.8837 20.8531C16.5095 21.2681 16.5095 21.9396 16.8837 22.3547L18.7994 24.4797C19.1723 24.8948 19.7802 24.8948 20.1531 24.4797C20.5273 24.0661 20.5273 23.3917 20.1531 22.9781L18.9156 21.6039L20.1531 20.2297C20.5273 19.8161 20.5273 19.1417 20.1531 18.7281C19.7802 18.313 19.1723 18.313 18.7994 18.7281Z",
    fill: "#5650FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5426 18.7708C25.5426 19.7483 24.8274 20.5417 23.9462 20.5417H17.5605C17.0318 20.5417 16.6027 21.0177 16.6027 21.6042C16.6027 22.1907 17.0318 22.6667 17.5605 22.6667H23.9462C25.8861 22.6667 27.4583 20.9228 27.4583 18.7708C27.4583 16.6189 25.8861 14.875 23.9462 14.875H21.3919C20.8632 14.875 20.4341 15.351 20.4341 15.9375C20.4341 16.524 20.8632 17 21.3919 17H23.9462C24.8274 17 25.5426 17.7933 25.5426 18.7708Z",
    fill: "#5650FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9041 4.52058L14.7777 10.761C13.332 11.6521 11.5721 11.6521 10.1264 10.761L0 4.52058V16.6458C0 17.6786 0.370368 18.6702 1.02809 19.4013C1.68709 20.1308 2.58108 20.5417 3.51211 20.5417H15.5401C15.6474 20.2923 15.7943 20.0572 15.9807 19.8518L17.8964 17.7267C18.3064 17.272 18.8364 17.0298 19.3741 17.0028C19.2349 16.6798 19.157 16.3186 19.157 15.9375C19.157 14.569 20.1582 13.4583 21.392 13.4583H23.9462C24.2744 13.4583 24.595 13.4952 24.9041 13.5646V4.52058ZM0.314174 2.28367L11.0561 8.90375C11.9246 9.43783 12.9795 9.43783 13.8479 8.90375L24.5899 2.28367C24.4162 1.86292 24.1761 1.47475 23.876 1.14042C23.217 0.410833 22.323 0 21.392 0C16.9692 0 7.93482 0 3.51211 0C2.58108 0 1.68709 0.410833 1.02809 1.14042C0.727965 1.47475 0.487864 1.86292 0.314174 2.28367Z",
    fill: "#5650FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendResultsIcon);
export default __webpack_public_path__ + "static/media/ResendResultsIcon.2ec9ff326ecc04c249d7e084ab856829.svg";
export { ForwardRef as ReactComponent };